import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './NotFound.module.css';

import { trackPageView } from '../utils/page-tracker';

const NotFound: React.FC = () => {
  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <div className={styles.notFound}>
      <motion.div 
        className={styles.content}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className={styles.errorCode}>404</div>
        <h1 className={styles.title}>页面未找到</h1>
        <p className={styles.description}>
          您访问的页面不存在或已被移除。
        </p>
        <a href="/" className={styles.button}>
          返回首页
        </a>
      </motion.div>
      
      <div className={styles.background}>
        <svg 
          className={styles.blob1}
          viewBox="0 0 200 200" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            fill="var(--accent)" 
            d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,79.6,-45.8C87.4,-32.6,90,-16.3,88.5,-0.9C87,14.6,81.4,29.2,73.6,42.9C65.8,56.6,55.9,69.5,42.6,74.9C29.2,80.3,14.6,78.2,-0.9,79.6C-16.3,81,-32.6,86,-44.3,80.6C-56,75.3,-63.1,59.7,-70.3,44.3C-77.5,29,-84.8,14.5,-86.2,-0.8C-87.5,-16.1,-82.9,-32.3,-73.4,-44.4C-63.9,-56.6,-49.5,-64.8,-35.6,-71.9C-21.8,-79.1,-10.9,-85.2,1.9,-88.6C14.6,-92,29.2,-92.8,44.7,-76.4Z" 
            transform="translate(100 100)" 
          />
        </svg>
        <svg 
          className={styles.blob2}
          viewBox="0 0 200 200" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            fill="var(--accent-hover)" 
            d="M39.3,-65.6C54.4,-60.9,72.6,-56.2,79.5,-44.7C86.4,-33.3,82,-15.6,78.3,-0.2C74.6,15.2,71.7,30.4,65.3,44.5C58.9,58.6,49,71.6,36,76.9C23,82.3,6.8,80,-8.8,76.9C-24.5,73.8,-39.5,69.9,-51.6,61.6C-63.6,53.3,-72.6,40.5,-77.1,26.4C-81.7,12.3,-81.7,-3.1,-76.9,-16.1C-72,-29.1,-62.3,-39.8,-50.7,-45.8C-39,-51.7,-25.3,-52.9,-12.8,-60.7C-0.3,-68.5,12,-81,24.3,-81.9C36.6,-82.9,48.9,-72.3,39.3,-65.6Z" 
            transform="translate(100 100)" 
          />
        </svg>
      </div>
    </div>
  );
};

export default NotFound; 